import {HStack, Icon,  Text} from "@chakra-ui/react";
import {HiOutlineCircleStack} from "react-icons/hi2";
import {Link as RouterLink, useLocation} from "react-router-dom";

const MenuItem = ({label, url = "/", icon, onClick}) => {
    const location = useLocation();
    const isActive = location.pathname === url || location.pathname.startsWith(`${url}/`);

    return (
        <HStack as={RouterLink} to={url} onClick={onClick} color={isActive ? "white" : "text.menu"} columnGap={3}
                bg={isActive ? "border.primary" : "transparent"}
                _hover={{bg: "border.primary", textDecoration: 'unset'}} py={4} w={'100%'} px={4} pl={6}
                borderLeft="3px solid" borderLeftColor={isActive ? "purple.400" : "transparent"}
                transition="background 0.2s ease-in-out">
            <Icon size={'md'} color={isActive ? "purple.400" : undefined}>
                {icon ?? <HiOutlineCircleStack/>}
            </Icon>
            <Text fontSize={16} fontWeight={isActive ? 600 : 400}>{label}</Text>
        </HStack>
    )
}

export default MenuItem;
